import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { patientListItemNeedsAttention, type PatientListByCategory } from "@/models/PatientSummaryModel.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Tab } from "@/uiKit/atoms/Tab.tsx";
import { TabList } from "@/uiKit/atoms/TabList.tsx";

export type PatientListMenuItems = "monitored" | "pregnant" | "all";

export type PatientListMenuProps = {
  selectedItem: PatientListMenuItems;
  patientListData: PatientListByCategory;
  className?: string;
};

export const PatientListMenu: React.FC<PatientListMenuProps> = ({ selectedItem, patientListData, className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  const notifyPregnantTab = selectedItem !== "pregnant" && patientListData.pregnant.some(patientListItemNeedsAttention);

  return (
    <TabList id="patient-list-menu" selectedTab={selectedItem} className={cx(styles.container, className)}>
      <Tab
        id="patient-list-menu-dt1-dt2"
        label={t("pages.patients.monitored")}
        count={patientListData.monitored.length}
        selected={selectedItem === "monitored"}
        value="monitored"
        link={{
          to: ".",
          search: {
            menu: "monitored",
          },
        }}
      />
      <Tab
        id="patient-list-menu-pregnant"
        notify={notifyPregnantTab}
        label={t("pages.patients.pregnant")}
        color={"orange"}
        count={patientListData.pregnant.length}
        selected={selectedItem === "pregnant"}
        value="pregnant"
        link={{
          to: ".",
          search: {
            menu: "pregnant",
          },
        }}
      />
      <Tab
        id="patient-list-menu-all"
        label={t("pages.patients.all")}
        count={patientListData.all.length}
        selected={selectedItem === "all"}
        value="all"
        link={{
          to: ".",
          search: {
            menu: "all",
          },
        }}
      />
    </TabList>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css``,
  label: css`
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing(4)};
    align-items: center;
    flex-wrap: nowrap;
    text-wrap: nowrap;
  `,
});
